import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import Flex from '@firsttable/web-components/atoms/Flex';
import Box from '@firsttable/web-components/atoms/Box';
import Title from '@firsttable/web-components/atoms/Title';
import Text from '@firsttable/web-components/atoms/Text';
import Divider from '@firsttable/web-components/atoms/Divider/Divider';
import Avatar from '@firsttable/web-components/atoms/Avatar';
import Link from '@firsttable/web-components/atoms/Link';
import { awsImage } from '@firsttable/functions';
import { TrackProvider } from '@components/analytics/context/AnalyticsContext';
import CloudfrontImage from '../../CloudfrontImage';
import NavLinkComponent from '../../GatsbyLinkConvertor';
import BlogCategories from '../BlogCategories';

const Wrapper = styled(Box)`
  border-radius: 2px;
  overflow: hidden;
  box-shadow: inset 0 0 0 1px ${themeGet('colors.grayscale.300')};
`;

type PostCardProps = {
  title?: string;
  categories?: any[];
  description?: string;
  avatarUrl?: string;
  imageUrl?: string;
  date?: string;
  author?: string;
  linkTo?: string;
};
const postCardDefaultCategories: any[] = [];
const PostCard = ({
  title = '',
  categories = postCardDefaultCategories,
  description = '',
  avatarUrl = '',
  imageUrl,
  date = '',
  author = '',
  linkTo,
}: PostCardProps) => {
  let BlogAvatar;
  if (avatarUrl) {
    BlogAvatar = <img className="img-fluid rounded-circle" src={avatarUrl} alt="" />;
  } else {
    BlogAvatar = <Avatar color="brand.red" width="36px" height="36px" />;
  }

  return (
    <Wrapper>
      <Box
        className="bg-pulse-animation"
        height={[null, '270px']}
        width="100%"
        bg="grayscale.300"
        display={['inline-block', 'block']}
        verticalAlign="top"
        textAlign="center">
        <CloudfrontImage
          src={awsImage(imageUrl, 450 * 2, 350 * 2)}
          width={450 * 2}
          height={350 * 2}
          alt={title}
          className="img-fluid"
          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
        />
      </Box>
      <Box p="24px">
        <BlogCategories categories={categories} />
        <Title size="h6" mt={7}>
          <TrackProvider link_name="post card">
            <Link NavComponent={NavLinkComponent} to={linkTo} expandClickableArea>
              {title}
            </Link>
          </TrackProvider>
        </Title>
        <Text>{description}</Text>
        <Box mt="24px">
          <Flex alignItems="center" minHeight="40px">
            <Divider flex={1} />
            <Box width="40px" ml="24px">
              {BlogAvatar}
            </Box>
          </Flex>
          <Text fontSize="s" mb={0}>
            {author && <Text as="strong">{author}</Text>}
            {author && date && <>&nbsp; • &nbsp;</>}
            <Text as="span" color="grayscale.600">
              {date}
            </Text>
          </Text>
        </Box>
      </Box>
    </Wrapper>
  );
};

PostCard.propTypes = {
  title: PropTypes.string,
  categories: PropTypes.array,
  description: PropTypes.string,
  avatarUrl: PropTypes.string,
  imageUrl: PropTypes.string,
  date: PropTypes.string,
  author: PropTypes.string,
};
export default PostCard;
